<template>
  <v-card class="card">
    <v-card
      :class="item.color"
      class="popped-card elevation-7"
      ripple
      router
      :to="{name: item.link}"
    >
      <div>
        <!-- <div class="text-xs-center pt-4 pb-4">
                    <v-progress-circular
                    :rotate="360"
                    :size="100"
                    :width="15"
                    :value="80"
                    :color="`${item.color} lighten-3`"
                    >
                    <span class="font-weight-bold">
                        $16,808
                    </span>
                    </v-progress-circular>
        </div>-->
        <v-card-title class="text-xs-center popped-icon">
          <v-icon size="72px">{{item.icon}}</v-icon>
        </v-card-title>
      </div>
    </v-card>
    <!-- <v-card-title primary-title> -->
    <!-- <v-container>                  -->
    <v-card-title class="flex-container-space-between">
      <div>
        <h3 class="title font-weight-regular mb-2">{{item.title}}</h3>
        <p class="font-weight-light grey--text">{{item.content}}</p>
      </div>
      <!-- <div>
                    <v-btn icon>
                        <v-icon color="grey">settings</v-icon>
                    </v-btn>
      </div>-->
    </v-card-title>
    <v-card-text>
      <div class="text-xs-right grey--text body-1" v-if="!!count">
        Month to date
        <v-chip :color="item.color" text-color="white" small>{{count}}</v-chip>
        <!-- <v-badge left :color="item.color">
                        <span slot="badge">
                            {{count}}
                        </span>
                        <span>Month to date</span>
                        <v-icon large color="grey lighten-1" >&nbsp;</v-icon>
        </v-badge>-->
        <!-- {{count}} in month to date</div> -->
      </div>
    </v-card-text>
    <!-- </v-container> -->
    <!-- </v-card-title> -->
    <!-- <v-card-actions>
            <v-btn flat :color="item.color" dark>
                See More
            </v-btn>
    </v-card-actions>-->

    <div style="width: 100%; height: 2px;" :class="item.color"></div>
  </v-card>
</template>

<script>
import Api from "@/services/api.js";
export default {
  name: "NavDashboardCard",
  data() {
    return {
      count: null,
      loading: false
    };
  },
  props: {
    item: Object
  },
  methods: {
    getCount() {
      if (this.item.link == "docket") {
        var routeString = `${this.item.link}s/count/${this.$store.state.shared.billingPeriod}`;
        //console.log(routeString);

        Api.get(routeString)
          .then(result => {
            this.count = result.data.result;
            this.loading = false;
          })
          .catch(err => {
            this.loading = false;
            this.snackError();
          });
      }
    }
  },
  mounted() {
    this.getCount();
  }
};
</script>

<style scoped>
.popped-icon {
  justify-content: center;
  padding-top: 50px;
  padding-bottom: 50px;
}

.popped-icon-small {
  justify-content: center;
  padding-top: 20px;
  padding-bottom: 20px;
}

.popped-card {
  margin: 15px;
  top: -20px;
  position: relative;
  border-radius: 6px;
  border-top-left-radius: 6px !important;
  border-top-right-radius: 6px !important;
}
</style>
